import { Button } from "@msuite/ui/button";
import { useLoading } from "@msuite/ui/hooks";
import { useTranslation } from "@msuite/ui/localization";
import { ConfirmModal, useAsyncModal } from "@msuite/ui/modal";
import { SettingsItem } from "@msuite/ui/settings";
import React from "react";
import { useNavigate } from "react-router";
import { client } from "@/hono";
import type { ServicePanelBaseProps } from "../shared";

export function DeleteService({ serviceId }: ServicePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const controller = useAsyncModal<string>();
	const deleteLoader = useLoading();
	const navigate = useNavigate();

	/** Functions */
	async function handleDeleteProject() {
		try {
			deleteLoader.start();
			const isConfirmed = await controller.confirm();
			if (!isConfirmed) {
				throw new Error("Service deletion not confirmed");
			}
			await client.organizations.services[":serviceId"].$delete({ param: { serviceId } });
			navigate("/services");
		} catch (error) {
			console.error("Failed to delete service:", error);
		} finally {
			deleteLoader.stop();
		}
	}

	/** Render */
	return (
		<React.Fragment>
			<SettingsItem
				title={t("general.delete")}
				description={t("organization.data.delete_service_confirm")}
			>
				<Button
					isLoading={controller.isPending || deleteLoader.isLoading}
					variant="danger-ghost"
					onClick={handleDeleteProject}
					data-cy="delete-project-button"
				>
					{t("projects.delete_project")}
				</Button>
			</SettingsItem>
			{controller.isOpen && (
				<ConfirmModal
					controller={controller}
					message={t("organization.data.delete_service_confirm")}
				/>
			)}
		</React.Fragment>
	);
}
